/**
 * 日付ユーティリティ（docs/pm/CONTRACTS.md §4）
 *
 * 内部表現の統一ルール:
 * - 日付: 'YYYY-MM-DD'
 * - 月:   'YYYY-MM'
 */

function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

/** 現在の年月を 'YYYY-MM' 形式で返す */
export function getCurrentYearMonth(): string {
  const now = new Date();
  return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}`;
}

/** 指定した年月の前月を 'YYYY-MM' 形式で返す（年またぎも考慮） */
export function getPreviousYearMonth(yearMonth: string): string {
  const [yearStr, monthStr] = yearMonth.split('-');
  const year = Number(yearStr);
  const monthIndex0 = Number(monthStr) - 1; // 0-indexed
  // Dateコンストラクタは月の範囲外（負数含む）を年繰り上げ/繰り下げで正規化する
  const prev = new Date(year, monthIndex0 - 1, 1);
  return `${prev.getFullYear()}-${pad2(prev.getMonth() + 1)}`;
}

/** 指定した年月の翌月を 'YYYY-MM' 形式で返す（年またぎも考慮） */
export function getNextYearMonth(yearMonth: string): string {
  const [yearStr, monthStr] = yearMonth.split('-');
  const year = Number(yearStr);
  const monthIndex0 = Number(monthStr) - 1; // 0-indexed
  const next = new Date(year, monthIndex0 + 1, 1);
  return `${next.getFullYear()}-${pad2(next.getMonth() + 1)}`;
}

/** 今日の日付を 'YYYY-MM-DD' 形式で返す */
export function getTodayDateString(): string {
  const now = new Date();
  return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
}

/** 'YYYY-MM-DD' を表示用の日本語表記に変換する（例: '8月10日'） */
export function formatDateJP(date: string): string {
  const [, monthStr, dayStr] = date.split('-');
  const month = Number(monthStr);
  const day = Number(dayStr);
  return `${month}月${day}日`;
}
